import Relay from 'react-relay';

class EndEventMutation extends Relay.Mutation {
  getMutation = () => Relay.QL`mutation {endEvent}`;

  getVariables() {
    const { event, timezone } = this.props;
    const { id, organizer, start, end, iCalUId } = event;
    const e = {
      id,
      iCalUId,
      organizer: organizer.email,
      originalStartDate: {
        date: start.unix(),
        timezone,
      },
      originalEndDate: {
        date: end.unix(),
        timezone,
      },
    };
    return e;
  }

  getFatQuery() {
    return Relay.QL`
      fragment on EndEventPayload {
        event {
          id
          iCalUId
          subject
          body
          startDate
          endDate
          occupancy
          location {
            displayName
          }
          organizer {
            displayName
            email
          }
          requiredAttendees {
            displayName
            email
          }
          optionalAttendees {
            displayName
            email
          }
          categories {
            name
          }
        }
      }
    `;
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        event: this.props.event.id,
      },
    }];
  }
}

export default EndEventMutation;



// WEBPACK FOOTER //
// ./src/js/Mutations/EndEventMutation.js